import { SearchRecommendationLayout } from './SearchRecommendation.layout';
import { createPremiumModule, ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { SearchRecommendationList } from './SearchRecommendationList';
import { SearchRecommendation } from './SearchRecommendation';
export const SearchRecommendationModule = createPremiumModule('searchRecommendation', [ModuleExtensions.customComponentsExtension(SearchRecommendationLayout, 'Layouts')], () => ({
  SDK: {
    Components: {
      SearchRecommendationList,
      SearchRecommendation
    }
  }
}));
export const RecommendationList = _ref => {
  let {
    Layouts = {},
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: Layouts
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.SDK.Components.SearchRecommendationList, props));
};
//# sourceMappingURL=SearchRecommendation.module.js.map